// Previsão de pagamento — "Fornecedor a definir" por GRUPO do orçamento (treinamento turma 5, 20/10; opção B
// do Rafael). A API manda `grupos_a_definir` no card a definir ({ id, nome, total, parcelado, saldo, itens,
// tem_item_sem_fornecedor }) e `grupo_orcamentoitem_id` em cada parcela. Toda parcela do card a definir diz o
// grupo: o teto vale por grupo e, quando o grupo recebe fornecedor no orçamento, as parcelas dele vão junto.

export const MSG_GRUPO_OBRIGATORIO = 'Escolha o grupo do orçamento desta parcela: quando o grupo receber fornecedor, a parcela passa para ele.';

const centavos = (v) => Math.round(Number(v || 0) * 100);

// "Fantasia — Razão social" (igual ao orçamento); sem os dois, o nome que a API já manda.
export function rotuloFornecedorPrevisao(forn = {}) {
    const fantasia = String(forn.fornecedor_nomefantasia || '').trim();
    const razao = String(forn.fornecedor_razaosocial || '').trim();
    if (fantasia && razao && fantasia.toUpperCase() !== razao.toUpperCase()) return `${fantasia} — ${razao}`;
    return fantasia || razao || forn.fornecedor_nome || '';
}

export function gruposADefinir(forn) {
    return Array.isArray(forn?.grupos_a_definir) ? forn.grupos_a_definir : [];
}

export function nomeGrupoADefinir(forn, grupoId) {
    if (!grupoId) return null;
    const grupo = gruposADefinir(forn).find((g) => String(g.id) === String(grupoId));
    return grupo ? grupo.nome : null;
}

// Grupos que aceitam parcela nova: os que ainda têm item sem fornecedor (+ o da parcela em edição).
export function opcoesGrupoParcela(forn, grupoAtual = null) {
    return gruposADefinir(forn)
        .filter((g) => g.tem_item_sem_fornecedor || (grupoAtual && String(g.id) === String(grupoAtual)))
        .map((g) => ({ value: String(g.id), label: g.nome }));
}

// Total/parcelado/saldo do grupo, com a parcela em edição FORA do parcelado (mesma conta da trava da API).
export function resumoGrupoParcela(forn, grupoId, parcelaEditando = null) {
    const grupo = gruposADefinir(forn).find((g) => String(g.id) === String(grupoId));
    if (!grupo) return null;
    let parcelado = Number(grupo.parcelado || 0);
    if (parcelaEditando && String(parcelaEditando.grupo_orcamentoitem_id || '') === String(grupoId)) {
        parcelado -= Number(parcelaEditando.valor || 0);
    }
    parcelado = Math.round(parcelado * 100) / 100;
    const total = Number(grupo.total || 0);
    return { total, parcelado, saldo: Math.max(0, Math.round((total - parcelado) * 100) / 100), itens: grupo.itens || [] };
}

// Camada 1 da validação (a 2 é erroGrupoDaParcelaADefinir na API). null = ok.
export function erroGrupoParcela({ aDefinir, grupoId, valor, resumo }) {
    if (!aDefinir) return null;
    if (!grupoId) return MSG_GRUPO_OBRIGATORIO;
    if (!resumo) return 'Este grupo não tem item sem fornecedor neste orçamento. Escolha outro grupo.';
    if (centavos(valor) > centavos(resumo.saldo)) {
        return `A parcela passa do saldo do grupo (R$ ${(resumo.saldo || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}).`;
    }
    return null;
}
